import { render, staticRenderFns } from "./_base-author-course-pricing.vue?vue&type=template&id=3aeb6c8e"
import script from "./_base-author-course-pricing.vue?vue&type=script&lang=js"
export * from "./_base-author-course-pricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports